import { Tables } from "@/lib/supabase/supabase_types_override";

interface QuestionWithResponses extends Tables<'question'> {
    response?: Tables<'response'>[] | null;
}

interface QuestionWithHasResponseAndResponses extends QuestionWithResponses {
    has_response: boolean;
}

export function populateQuestionWithHasResponse<Q extends QuestionWithResponses = QuestionWithResponses>(question: Q): QuestionWithHasResponseAndResponses {
    return {
        ...question,
        has_response: question.response && Array.isArray(question.response) && question.response.length > 0 ? true : false,
    }
}

export function populateQuestionsWithHasResponse(questions?: QuestionWithResponses[] | null): QuestionWithHasResponseAndResponses[] {
    return questions ? questions.map(populateQuestionWithHasResponse) : [];
}